import { render, staticRenderFns } from "./CompanyDepartmentFormPopupWrappable.vue?vue&type=template&id=7993965a&scoped=true&lang=pug&"
import script from "./CompanyDepartmentFormPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./CompanyDepartmentFormPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDepartmentFormPopupWrappable.vue?vue&type=style&index=0&id=7993965a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7993965a",
  null
  
)

export default component.exports